import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

import * as enUS from '../../assets/resource-files/autogenerated/en-US.json';
import * as jaJP from '../../assets/resource-files/autogenerated/ja-JP.json';
import * as deDE from '../../assets/resource-files/autogenerated/de-DE.json';
import * as esES from '../../assets/resource-files/autogenerated/es-ES.json';
import * as frFR from '../../assets/resource-files/autogenerated/fr-FR.json';

export interface ILanguage {
  code: string;
  name: string;
  country: string;
  countryCode: string;
  caption: string;
}

export enum LanguageEnum {
  ENGLISH = 'en-US',
  JAPANESE = 'ja-JP',
  GERMAN = 'de-DE',
  SPANISH = 'es-ES',
  FRENCH = 'fr-FR',
}

/** Future languages to support -> es-MX, fr-FR, it-IT, de-DE, ko-KR, pt-BR, ru-RU, tr-TR, zh-CN */

export const SUPPORTED_LANGUAGES: ILanguage[] = [
  { code: LanguageEnum.ENGLISH, name: 'English', country: 'United States', countryCode: 'EN', caption: 'English (EN)' },
  { code: LanguageEnum.JAPANESE, name: '日本語', country: 'Japan', countryCode: 'JP', caption: '日本語 (JP)' },
  { code: LanguageEnum.GERMAN, name: 'Deutsch', country: 'Germany', countryCode: 'DE', caption: 'Deutsch (DE)' },
  { code: LanguageEnum.SPANISH, name: 'Español', country: 'Spain', countryCode: 'ES', caption: 'Español (ES)' },
  { code: LanguageEnum.FRENCH, name: 'Français', country: 'France', countryCode: 'FR', caption: 'Français (FR)' },
  // { code: 'te-st', name: 'language-selector-language-test', country: 'language-selector-country-test' },
];

@Injectable({
  providedIn: 'root',
})
export class XSi18nService {
  private langList: string[];
  private DefaultDict: { [key: string]: string };
  short_date_format: string;
  year_format: string;

  constructor(private translate: TranslateService, @Inject('LOCALSTORAGE') private localStorage: Storage) {
    translate.setDefaultLang('en-US');
    console.log('xsi18nboot');
    this.initLang();

    const currentLang = translate.getBrowserLang(); // this will return the language: en, ko,ru
    const currentLangCulture = translate.getBrowserCultureLang(); // this will return the culture too:en-US, zh-TW

    const language = this.localStorage.getItem('lang');
    if (!!language) {
      translate.use(language);
    } else if (this.langList.indexOf(currentLangCulture) > -1) {
      translate.use(currentLangCulture);
    } else if (this.DefaultDict[currentLang] !== undefined) {
      translate.use(this.DefaultDict[currentLang]);
    } else {
      translate.use(translate.getDefaultLang());
      this.localStorage.setItem('lang', translate.getDefaultLang());
    }
    moment.locale(translate.currentLang);

    this.translate.get('timeFormatFilter_MonthDay_Format').subscribe(value => (this.short_date_format = value));
    this.translate.get('timeFormatFilter_Year_Format').subscribe(value => (this.year_format = value));
  }

  private initLang = () => {
    this.translate.setTranslation('en-US', (enUS as any).default ? (enUS as any).default : enUS);
    this.translate.setTranslation('ja-JP', (jaJP as any).default ? (jaJP as any).default : jaJP);
    this.translate.setTranslation('de-DE', (deDE as any).default ? (deDE as any).default : deDE);
    this.translate.setTranslation('es-ES', (esES as any).default ? (esES as any).default : esES);
    this.translate.setTranslation('fr-FR', (frFR as any).default ? (frFR as any).default : frFR);

    this.langList = ['en-US', 'ja-JP', 'de-DE', 'es-ES', 'fr-FR'];

    this.DefaultDict = {};
    this.DefaultDict['en'] = 'en-US';
    this.DefaultDict['ja'] = 'ja-JP';
    this.DefaultDict['de'] = 'de-DE';
    this.DefaultDict['es'] = 'es-ES';
    this.DefaultDict['fr'] = 'fr-FR';
  };
}
